export const PRESSKIT = "PRESSKIT";
export const PRESSKIT_LOADING = "PRESSKIT_LOADING";
